<div class="comptage-container">
  <div class="comptage-header">
    <h3>Comptage</h3>
    <p>Paramétrez les valeurs électriques du projet et vérifiez le type de comptage déduit.</p>
  </div>
  @if (isProjectLocked()) {
  <div class="alert alert-warning mb-4">
    Projet verrouillé (VALIDE/TERMINE): les modifications de comptage sont bloquées.
  </div>
  }
  @if (localErrorMessage()) {
  <div class="alert alert-error mb-4">{{ localErrorMessage() }}</div>
  }
  <div class="comptage-rule-banner" role="status" aria-live="polite">
    <span class="label">Règle de comptage active</span>
    <span class="value">
      @if (activeRule()) {
      {{ activeRule()!.name }}
      } @else {
      Aucune règle active (options par défaut)
      }
    </span>
    <button type="button" class="rule-link" (click)="openRuleDialog()">Voir la règle</button>
  </div>
  @if (showRuleDialog()) {
  <div class="modal-overlay" (click)="closeRuleDialog()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Règle de comptage active</h3>
        <button type="button" class="modal-close" (click)="closeRuleDialog()" aria-label="Fermer">×</button>
      </div>
      <div class="modal-body">
        @if (activeRule()) {
        <div class="rule-table">
          <div class="rule-row">
            <span class="rule-label">Nom</span>
            <span class="rule-value rule-pill">{{ activeRule()!.name }}</span>
          </div>
          <div class="rule-row">
            <span class="rule-label">Tension supérieure à</span>
            <span class="rule-value">{{ activeRule()!.minTension }}</span>
          </div>
          <div class="rule-row">
            <span class="rule-label">Puissance supérieure à</span>
            <span class="rule-value">{{ activeRule()!.minPuissance }}</span>
          </div>
          <div class="rule-row">
            <span class="rule-label">Options tension</span>
            <span class="rule-value">
              @if (voltageOptions.length) {
              <span class="chip-group">
                @for (opt of voltageOptions; track opt) {
                <span class="chip">{{ opt }}</span>
                }
              </span>
              } @else {
              —
              }
            </span>
          </div>
          <div class="rule-row">
            <span class="rule-label">Options puissance</span>
            <span class="rule-value">
              @if (puissanceOptions.length) {
              <span class="chip-group">
                @for (opt of puissanceOptions; track opt) {
                <span class="chip">{{ opt }}</span>
                }
              </span>
              } @else {
              —
              }
            </span>
          </div>
        </div>
        } @else {
        <p class="rule-empty">Aucune règle active. Les options par défaut sont utilisées.</p>
        <div class="rule-table">
          <div class="rule-row">
            <span class="rule-label">Options tension</span>
            <span class="rule-value">
              @if (voltageOptions.length) {
              <span class="chip-group">
                @for (opt of voltageOptions; track opt) {
                <span class="chip">{{ opt }}</span>
                }
              </span>
              } @else {
              —
              }
            </span>
          </div>
          <div class="rule-row">
            <span class="rule-label">Options puissance</span>
            <span class="rule-value">
              @if (puissanceOptions.length) {
              <span class="chip-group">
                @for (opt of puissanceOptions; track opt) {
                <span class="chip">{{ opt }}</span>
                }
              </span>
              } @else {
              —
              }
            </span>
          </div>
        </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeRuleDialog()">Fermer</button>
      </div>
    </div>
  </div>
  }
  <div class="table-responsive">
    <table class="modern-table">
      <thead>
        <tr>
          <th>Paramètre</th>
          <th>Sélection</th>
          <th>Valeur actuelle</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Valeur de Tension</td>
          <td>
            <mat-form-field appearance="outline" class="compact">
              <mat-select [value]="project.voltage" (valueChange)="updateVoltage($event)"
                [disabled]="isProjectLocked() || readonlyMode" placeholder="Sélectionner">
                @for (option of voltageOptions; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td>{{ project.voltage || '—' }}</td>
        </tr>
        <tr>
          <td>Transformateur 1</td>
          <td class="multi-select">
            <mat-form-field appearance="outline" class="mini-compact">
              <mat-select [value]="project.puissanceTransfo1" (valueChange)="updatePuissance1($event)"
                [disabled]="isProjectLocked() || readonlyMode" placeholder="Puissance">
                @for (option of puissanceOptions; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mini-compact">
              <mat-select [value]="project.typeTransfo1" (valueChange)="updateType1($event)"
                [disabled]="isProjectLocked() || readonlyMode" placeholder="Type">
                @for (option of typeOptions; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td>
            <div class="multi-value">
              <span>{{ project.puissanceTransfo1 || '—' }}</span>
              @if (project.typeTransfo1) {
              <span class="type-pill">{{ project.typeTransfo1 }}</span>
              }
            </div>
          </td>
        </tr>
        <tr>
          <td>Transformateur 2</td>
          <td class="multi-select">
            <mat-form-field appearance="outline" class="mini-compact">
              <mat-select [value]="project.puissanceTransfo2" (valueChange)="updatePuissance2($event)"
                [disabled]="isProjectLocked() || readonlyMode" placeholder="Puissance">
                @for (option of puissance2Options; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mini-compact">
              <mat-select [value]="project.typeTransfo2" (valueChange)="updateType2($event)"
                [disabled]="isProjectLocked() || readonlyMode || project.puissanceTransfo2 === 'N/A'"
                placeholder="Type">
                @for (option of type2Options; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td>
            <div class="multi-value">
              <span>{{ project.puissanceTransfo2 || '—' }}</span>
              @if (project.typeTransfo2 && project.typeTransfo2 !== 'N/A') {
              <span class="type-pill">{{ project.typeTransfo2 }}</span>
              }
            </div>
          </td>
        </tr>
        <tr>
          <td>Comptage Déduit</td>
          <td>
            <span class="text-muted italic">Calculé automatiquement</span>
          </td>
          <td>
            <span class="comptage-badge" [attr.data-type]="project.comptage">{{ project.comptage || '—' }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>